import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const Ctx = createContext(null);
const LS_KEY = "lsp_tester_state_v1";

const DEFAULTS = {
    baseUrl: "https://codecrafters.getkosh.com/backend/test4/lsp-suite/", // sandbox from PDF :contentReference[oaicite:1]{index=1}
    username: "test_empower",
    password: "empower101",
    token: "",
    partnerLoanId: "",
};

export function LspProvider({ children }) {
    const [state, setState] = useState(() => {
        try {
            const saved = JSON.parse(localStorage.getItem(LS_KEY) || "null");
            return saved ? { ...DEFAULTS, ...saved } : DEFAULTS;
        } catch {
            return DEFAULTS;
        }
    });

    useEffect(() => {
        localStorage.setItem(LS_KEY, JSON.stringify(state));
    }, [state]);

    const api = useMemo(() => {
        return {
            state,
            setBaseUrl: (baseUrl) => setState((s) => ({ ...s, baseUrl })),
            setUsername: (username) => setState((s) => ({ ...s, username })),
            setPassword: (password) => setState((s) => ({ ...s, password })),
            setToken: (token) => setState((s) => ({ ...s, token })),
            setPartnerLoanId: (partnerLoanId) => setState((s) => ({ ...s, partnerLoanId })),
            reset: () => setState(DEFAULTS),
        };
    }, [state]);

    return <Ctx.Provider value={api}>{children}</Ctx.Provider>;
}

export function useLsp() {
    const v = useContext(Ctx);
    if (!v) throw new Error("useLsp must be used inside LspProvider");
    return v;
}
